import { FileSearch } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Card, CardContent } from '@/components/ui/card';
import { usePageTitle } from '@/hooks/usePageTitle';

export const ReviewHistoryPage = () => {
  usePageTitle('Review History');
  return (
    <div className="space-y-8">
      <header>
        <p className="text-muted-foreground text-sm tracking-[0.3em] uppercase">Review History</p>
        <h1 className="text-3xl font-bold tracking-tight">Past Campaign Reviews</h1>
        <p className="text-muted-foreground mt-2">View all historical AI review sessions</p>
      </header>

      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12">
          <FileSearch className="text-muted-foreground mb-4 h-16 w-16" />
          <h3 className="mb-2 text-xl font-semibold">Select a Campaign</h3>
          <p className="text-muted-foreground mb-6 text-center">
            Go to{' '}
            <Link to="/reviews/campaigns" className="text-primary hover:underline">
              Campaign Reviews
            </Link>{' '}
            to view review history for specific campaigns
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
